const appVars = {
  apiUrl: 'https://blue.firstechllc.com/api/ft/V1/',
  apiUrlBase: 'https://blue.firstechllc.com/api/'
}

export default appVars
